import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    box: {
      // lets keep it
      /*width: 184,
      height: 184,

      '& img': {
        width: '100%',
        height: 'auto',
        borderRadius: '50%',
        overflow: 'hidden',
        border: '1px solid white',
      },*/

      '& .assistant': {
        '& .assistant-avatar': {
          position: 'relative',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '1px solid white',
          zIndex: '10',
        },

        '&.with-hover ': {
          '& .assistant-mute': {
            display: 'none',
          },

          '&:hover': {
            '& .assistant-mute': {
              display: 'inherit',
            },
          },
        },

        '& .ai-assistant-canvas': {
          position: 'absolute',
          marginLeft: '-288px',
          marginTop: '-96px',
        },

        '& .assistant-mute': {
          width: '40px',
          height: '40px',
          background: colors.white,
          border: '1px solid ' + colors.white,
          boxShadow: '0px 0px 2.7px 6px rgba(255, 255, 255, 0.5)',
          borderRadius: '50%',
          position: 'fixed',
          top: '158px',
          zIndex: '100',
          cursor: 'pointer',

          svg: {
            marginTop: '7px',
            marginLeft: '7px',
          },

          '&.muted svg': {
            color: colors.red,
          },
        },
      },
    },
  };
};
